import { useEffect, useState, useContext } from 'react';
import { bool, func } from 'prop-types';
import Modal from '../../shared/Modal';
import { Box, Stack, Flex, Cluster } from '../../shared/layouts';
import axios from 'axios';
import Button from '../../shared/Button';
import WhiteLabelContext from "../../../context/WhiteLabelContext";
import {useTranslation} from "react-i18next";

const RecoveryCodesGenerateModal = ({
  isOpen,
  onRequestClose,
  onBtnClick,
  hasRecoveryCodes,
}) => {
  const { t } = useTranslation();
  const [codes, setCodes] = useState([]);
  const [getNewCodes, setGetNewCodes] = useState(false);
  const { platformName } = useContext(WhiteLabelContext);

  useEffect(() => {
    if (isOpen && hasRecoveryCodes) {
      axios
        .get('/user/settings/recovery-codes/setup')
        .then((resp) => {
          setCodes(resp.data.codes);
        })
        .catch((err) => console.log(err));
    }
  }, [isOpen, hasRecoveryCodes]);

  useEffect(() => {
    if (getNewCodes || (!hasRecoveryCodes && isOpen)) {
      axios
        .post('/user/settings/recovery-codes/setup')
        .then((resp) => {
          setCodes(Object.values(resp.data.codes));
        })
        .catch((err) => console.log(err))
        .finally(setGetNewCodes(false));
    }
  }, [getNewCodes, hasRecoveryCodes, isOpen]);

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} minWidth="554px" showProgressBar>
      <Stack space="l">
        <Flex flexDirection="column">
          <Box
            fontScale="xl"
            fontWeight="bold"
            margin="40px 0 15px"
            textAlign="center"
          >
            {t('Herstelcodes')}
          </Box>
          <Box textAlign="center" marginBottom="32px">
            {t('Kun je een keer niet inloggen via je normale manier van authenticatie? Gebruik dan een herstelcode om alsnog toegang te krijgen tot je account.')}
          </Box>
          <Box textAlign="center" marginBottom="32px">
            {t(
              'LET OP! Je kunt elke code maar één keer gebruiken. Bewaar deze codes dus goed en op een veilige plek. En zorg ervoor, dat je op tijd nieuwe codes genereert voor je ze allemaal hebt verbruikt. Zo word je nooit buitengesloten en kun je altijd in {{platformName}}.',
              {platformName}
            )}
          </Box>

          <Box bg="background" p={{ mobile: '24px 16px', md: "24px 32px" }} m={{ mobile: '0 -16px', md: "0 -32px"}} textAlign="center">
            {codes.map((code, i) => (
              <Box
                key={i}
                m={{ mobile: '8px 0 ', md: "m" }}
                css={(theme) => ({
                  letterSpacing: '2px',
                  textDecoration: code.used ? 'line-through' : null,
                  textDecorationColor: code.used ? theme.colors.alert : null,
                })}
              >
                {code.code.match(/.{4}/g).join(' - ')}
              </Box>
            ))}
            {codes.some((code) => code.used) && (
              <Flex justifyContent="center">
                <Button
                  variant="symantic"
                  css={(theme) => ({
                    textDecoration: 'underline',
                    color: theme.colors.primary,
                    marginTop: theme.space.large,
                    fontSize: theme.fontSizes.s,
                    fontWeight: theme.fontWeights.bold,
                  })}
                  onClick={() => setGetNewCodes((val) => !val)}
                >
                  {t('Nieuwe codes genereren')}
                </Button>
              </Flex>
            )}
          </Box>
        </Flex>
        <Cluster mt="xl" display="flex" justifyContent="flex-end" hGap="m">
          <Button onClick={onBtnClick}>{t('Sluiten')}</Button>
        </Cluster>
      </Stack>
    </Modal>
  );
};

RecoveryCodesGenerateModal.propTypes = {
  isOpen: bool,
  onRequestClose: func,
  onBtnClick: func,
  onSetupFinish: func,
  hasRecoveryCodes: bool,
};

RecoveryCodesGenerateModal.defaultProps = {
  isOpen: false,
  hasRecoveryCodes: false,
  onRequestClose: () => {},
  onBtnClick: () => {},
  onSetupFinish: () => {},
};

export default RecoveryCodesGenerateModal;
